import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf54849a")

_pushScopeId("data-v-bf54849a")
const _hoisted_1 = {
  id: "outgoing-bagging",
  class: "pt-8 bg-white flex flex-col text-14px overflow-hidden h-screen relative w-full"
}
const _hoisted_2 = { class: "flex z-20" }
const _hoisted_3 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card flex justify-content-center" }, null, -1)
const _hoisted_5 = { class: "pl-2" }
const _hoisted_6 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_7 = { class: "flex flex-col gap-x-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-14px font-montserrat text-black-lp-300 gap-y-2"
}
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "text-14px font-montserrat text-black-lp-300 gap-y-2"
}
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "hidden" }
const _hoisted_14 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_MultipleSelect = _resolveComponent("MultipleSelect")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DisputeSummary = _resolveComponent("DisputeSummary")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1),
            _hoisted_4,
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('bagging.placeholderSearch')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _createVNode(_component_time_range_picker, {
              onSelect: _ctx.setDateRange,
              default: _ctx.$t('custom'),
              showOptions: 
            `${_ctx.$t('custom')}, ${_ctx.$t('hari ini')}, ${_ctx.$t('7 hari terakhir')}, ${_ctx.$t(
              '14 hari terakhir'
            )}`
          ,
              minDate: _ctx.minDate,
              maxDate: _ctx.maxDate,
              onDayClick: _ctx.setDay,
              isOptionDisabled: !_ctx.isStartDate,
              onCancelRangePick: _ctx.cancelRangePick,
              customDefaultValue: true,
              startDate: _ctx.yesterday,
              endDate: _ctx.today
            }, null, 8, ["onSelect", "default", "showOptions", "minDate", "maxDate", "onDayClick", "isOptionDisabled", "onCancelRangePick", "startDate", "endDate"]),
            _createVNode("div", _hoisted_5, [
              (_ctx.hubIdOptions.length > 0)
                ? (_openBlock(), _createBlock(_component_MultipleSelect, {
                    key: 0,
                    modelValue: _ctx.hubIdSelected,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.hubIdSelected = $event)),
                    options: _ctx.hubIdOptions,
                    onChange: _ctx.onChangeHubIdSelected,
                    onClear: _ctx.onChangeHubIdSelected
                  }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.ableToCreate)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlerModalSTTPaid(true))),
                title: _ctx.$t('bagging.titleButtonCreate'),
                textColor: "white"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.isLoading && !_ctx.periodeStart && !_ctx.periodeEnd)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            data: "Bagging"
          }))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (
          !_ctx.isLoading &&
            _ctx.baggingDisputeSummary &&
            _ctx.isBaggingDisputeSummaryHasPermission
        )
              ? (_openBlock(), _createBlock(_component_DisputeSummary, {
                  key: 0,
                  baggingDisputeSummaryData: _ctx.baggingDisputeSummary
                }, null, 8, ["baggingDisputeSummaryData"]))
              : _createCommentVNode("", true),
            _createVNode(_component_TableV2, {
              "data-testid": "outgoing-bagging-list-table",
              columns: _ctx.columns,
              data: _ctx.baggingList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
              totalColumnFreeze: 1,
              isRightFreeze: true,
              onRequest: _ctx.fetchBaggingList,
              errorCause: _ctx.errorCause,
              isDetailAble: _ctx.ableToDetail,
              onClick: _ctx.goToDetail,
              isCheckBox: _ctx.isShowRTC,
              readyToProcess: _ctx.readyToProcess,
              "onUpdate:readyToProcess": _cache[4] || (_cache[4] = ($event: any) => (_ctx.readyToProcess = $event)),
              readyToDelete: _ctx.readyToDelete,
              "onUpdate:readyToDelete": _cache[5] || (_cache[5] = ($event: any) => (_ctx.readyToDelete = $event)),
              isHideHeadCheckbox: "",
              customModelCheckbox: "",
              customContentHeadCheckbox: "",
              hiddenPagination: "block",
              groupAction: "",
              borderTop: false,
              isSpaceBottom: true,
              isSpaceTop: false,
              marginTopCheckbox: false
            }, _createSlots({ _: 2 }, [
              (_ctx.readyToProcess.length || _ctx.readyToDelete.length)
                ? {
                    name: "contentHeadCheckbox",
                    fn: _withId(() => [
                      _createVNode("div", _hoisted_6, [
                        _createVNode("div", _hoisted_7, [
                          (_ctx.readyToProcess.length)
                            ? (_openBlock(), _createBlock("p", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_ctx.$t("bagging.proses")) + " ", 1),
                                _createVNode("strong", _hoisted_9, _toDisplayString(_ctx.readyToProcess.length) + " " + _toDisplayString(_ctx.$t("bagging.noBagging")), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("bagging.toReadyToCargo")) + " ", 1),
                                _hoisted_10
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.readyToDelete.length)
                            ? (_openBlock(), _createBlock("p", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_ctx.$t("bagging.hapus")) + " ", 1),
                                _createVNode("strong", _hoisted_12, _toDisplayString(_ctx.readyToDelete.length) + " " + _toDisplayString(_ctx.$t("bagging.noBagging")), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("bagging.fromReadyToCargo")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_lp_button, {
                          onClick: _ctx.showPopupUpdateToReadyToCargo,
                          title: _ctx.$t('bagging.proses'),
                          textColor: "white"
                        }, null, 8, ["onClick", "title"])
                      ])
                    ])
                  }
                : undefined
            ]), 1032, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "isDetailAble", "onClick", "isCheckBox", "readyToProcess", "readyToDelete"])
          ], 64)),
      _withDirectives(_createVNode("div", _hoisted_13, null, 512), [
        [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onSubmit: _ctx.goToCreate,
        title: _ctx.$t('bagging.modalTitleSTTPaid'),
        message: _ctx.$t('bagging.modalMessageSTTPaid'),
        image: "payment/payment-cash-illustration",
        textSuccess: "OK",
        class: "px-8"
      }, null, 8, ["onSubmit", "title", "message"]), [
        [_vShow, _ctx.showModalSTTPaid]
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
})